import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import FetchHook from "../../Api/FetchHooks";
import TableComponent from "../../Components/TableComponent";
import moment from "moment";
import PageLoader from "../../Components/PageLoader";
import { LoadingButton } from "@mui/lab";
import PutHooks from "../../Api/PutHook";
import { useForm } from "react-hook-form";
import AlertComponent from "../../Components/AlertComponent";
import ActionDialog from "../../Components/ActionDialog";
import UseServerTable from "../../Hooks/UseServerTable";
import ErrorDisplay from "../../Components/ErrorDisplay";
import { AllInbox } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { formatCurrencyV2 } from "../../utils/helpers";

const TransactionsWithdrawReq = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const loggedInUser = useSelector((state) => state.auth.user);

  const [user, setUser] = useState(loggedInUser);
  const [status, setStatus] = useState("pending");
  const [data, setData] = useState([]);
  const [poolRequest, setPoolRequest] = useState();
  const [approval, setApproval] = useState("");
  const [dialog, setDialog] = useState({
    open: false,
    type: null,
    label: null,
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const openDialog = (type, label) => setDialog({ open: true, type, label });
  const closeDialog = () => setDialog({ open: false, type: null, label: null });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  // useEffect(() => {
  //   if (fetch === 0) {
  //     request({
  //       url: `/request_transaction?status=${status}`,
  //     });
  //     setFetch(1);
  //   }

  //   if (response && response.data.StatusCode === 0) {
  //     setData(response.data.Reversal);
  //   }
  // }, [fetch, response]);

  const { gridProps, error, refresh } = UseServerTable({
    baseUrl: `/request_transaction?status=${status}`,
    onSuccess: (data) => {
      setData(data.Reversal || []);
    },
  });

  useEffect(() => {
    if (error) {
      setSnackbar({
        open: true,
        message: error.message,
        severity: error.severity,
      });
    }
  }, [error]);

  const columns = [
    {
      field: "id",
      headerName: "#",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "entity_id",
      headerName: "Entity id",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "amount",
      headerName: "Amount",
      flex: 1,
      minWidth: 150,
      valueFormatter: (params) => formatCurrencyV2(params?.value),
    },
    // {
    //   field: "status",
    //   headerName: "Status",
    //   flex: 1,
    //   minWidth: 200,
    // },
    {
      field: "active_status",
      headerName: "Active Status",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "description",
      headerName: "Description",
      flex: 1,
      minWidth: 350,
    },
    {
      field: "start_date",
      headerName: "Start date",
      flex: 1,
      minWidth: 200,
      valueFormatter: (params) =>
        moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    },
    {
      field: "Action",
      headerName: "",
      renderCell: (row) => (
        <>
          {row.row.active_status === "pending" && (
            <Button
              variant="outlined"
              onClick={() => {
                // handleModal();
                openDialog(
                  "transaction_withdraw_approval",
                  "Transaction withdraw approval",
                );
                setPoolRequest(row.row);
              }}
            >
              Action
            </Button>
          )}
        </>
      ),
    },
  ];

  return (
    <Box sx={{ padding: "20px" }}>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <ActionDialog
        open={dialog.open}
        onClose={closeDialog}
        dialogType={dialog.type}
        dialogLabel={dialog.label}
        user={user}
        onSuccess={refresh}
        data={poolRequest}
      />

      {/* <Dialog open={open} onClose={handleModal}>
        <DialogTitle>Transaction withdraw approval</DialogTitle>
        <DialogContent
          sx={{
            my: "20px",
            width: { lg: "400px" },
          }}
        >
          <form onSubmit={handleSubmit(requestApproval)}>
            <FormControl
              fullWidth
              sx={{
                my: "20px",
              }}
            >
              <InputLabel id="status">Status</InputLabel>
              <Select
                labelId="status"
                id="status"
                defaultValue=""
                value={approval}
                label="Status"
                onChange={(e) => setApproval(e.target.value)}
                required
              >
                <MenuItem value="ACCEPTED">Accept </MenuItem>
                <MenuItem value="DECLINED">Decline </MenuItem>
              </Select>
            </FormControl>

            <Box
              sx={{
                pt: "40px",
                display: "flex",
                direction: "row",
                justifyContent: "space-between",
              }}
            >
              <Button type="reset" variant="outlined" onClick={handleModal}>
                Cancel
              </Button>
              <LoadingButton
                variant="contained"
                type="submit"
                loading={approvalLoading}
              >
                Submit
              </LoadingButton>
            </Box>
          </form>
        </DialogContent>
      </Dialog> */}

      <Card>
        <CardHeader
          title={
            <Typography variant="h6">Transactions withdraw requests</Typography>
          }
          action={
            <FormControl sx={{ width: "200px" }}>
              <InputLabel id="status" size="small">
                Status
              </InputLabel>

              <Select
                labelId="status"
                id="status"
                value={status}
                label="status"
                onChange={(e) => {
                  setStatus(e.target.value);
                }}
                size="small"
              >
                <MenuItem value="accepted">Accepted</MenuItem>
                <MenuItem value="rejected">Rejected</MenuItem>
                <MenuItem value="pending">Pending</MenuItem>
              </Select>
            </FormControl>
          }
        />

        <CardContent>
          {data.length > 0 ? (
            <TableComponent data={data} columns={columns} {...gridProps} />
          ) : gridProps.loading ? (
            <PageLoader />
          ) : (
            <ErrorDisplay
              message="You have no transactions!"
              icon={
                <AllInbox color="secondary" sx={{ mx: "auto", fontSize: 80 }} />
              }
            />
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default TransactionsWithdrawReq;
